<div class="card-container" [ngStyle]="{ 'background-color': backgroundColor ? textHexColor : '#fff' }">
    <p class="label-name medium" [ngClass]="{ 'white-label': backgroundColor }">{{ text | translate }}</p>
    <p class="count" [ngStyle]="{ color: !backgroundColor ? textHexColor : '#fff' }">{{ totalCount }}</p>
</div>
